import {authHeader} from "../helpers/auth-header";

export const accountService = {
    getDemandPosts,
    getSupplyPosts
};

function getDemandPosts(){
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/account/demands', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSupplyPosts(){
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader(), 'Content-Type': 'application/json' }
    };

    return fetch(process.env.VUE_APP_ROOT_API + '/account/supplies', requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            return Promise.reject(data);
        }
        return data;
    });
}
